// @flow

const _default: 'default' = 'default';

export default _default;
export const white: 'white' = 'white';
